import { getNodeCustomField } from '@/features/editor/documentCustomFields';
import type { ProjectNode } from '@/shared/types/projectData';
import type { ReportNode } from '../types/report';

export const REPORT_OPEN_TARGET_STORAGE_KEY = 'reports-open-report-id';

export const isReportNode = (node: ProjectNode): node is ReportNode =>
  Boolean(getNodeCustomField(node, 'isReport', 'is_report') ?? String(node.id).startsWith('report-'));
